var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('upload',{attrs:{"action":_vm.action,"file-list":_vm.value},on:{"change":_vm.handleChange}},[_c('a-button',{staticClass:"fluid",attrs:{"icon":"upload"}},[_vm._v(" Załącz certyfikat ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }